import { User } from "oidc-client-ts"
import { ClientColors } from "./app_colors";

function getBarColorFactory(chartType) {

  const user = getUser();
  const userGroupName = user.profile['cognito:groups'][0]


  if (chartType === 'bar') {
    let index = 0;
    const barColorsLength = 6;
    return () => {
      const color = ClientColors[userGroupName]['barGraph'][index];
      index = (index + 1) % barColorsLength; // Cycle through colors
      return color;
    };

  } else {
    let index = 0;
    const scatterPlotColorsLength = 10;
    return () => {
      const color = ClientColors[userGroupName]['stroke'][index];
      index = (index + 1) % scatterPlotColorsLength; // Cycle through colors
      return color;
    };
  }
}


function getUser() {
  const authority = process.env.REACT_APP_COGNITO_AWS_AUTHORITY
  const client_id = process.env.REACT_APP_COGNITO_AWS_CLIENT_ID
  const oidcStorage = sessionStorage.getItem(`oidc.user:${authority}:${client_id}`)
  if (!oidcStorage) {
    return null;
  }
  return User.fromStorageString(oidcStorage);
}


function datasetsAndLabels(plotData, chartType, selectedX) {
  const getBarColor = getBarColorFactory(chartType);

  const x_axis_labels = plotData.labels;
  const response_dataSets = plotData.datasets;
  const calculatedDataset = [];
  const clusterValues = [];
  if (selectedX === 'Cluster') {
    response_dataSets.forEach((object) => {
      clusterValues.push(object.data[0]);
    });
    calculatedDataset.push({
      label: 'Cluster data',
      data: clusterValues,
      backgroundColor: clusterValues.map(() => getBarColor()),
    });
  } else {
    response_dataSets.forEach((object) => {
      calculatedDataset.push({
        label: object.cluster_lable,
        backgroundColor: object.data.map(() => getBarColor()),
        data: object.data,
      });
    });
  }
  return {
    xGrouped: x_axis_labels,
    yGrouped: calculatedDataset,
  };
}

export { getBarColorFactory, datasetsAndLabels }; 